export const GET_APPLICANTS_REQUEST = "GET_APPLICANTS_REQUEST";
export const GET_APPLICANTS_RESPONSE = "GET_APPLICANTS_RESPONSE";

export const GET_APPLICANT_REQUEST = "GET_APPLICANT_REQUEST";
export const GET_APPLICANT_RESPONSE = "GET_APPLICANT_RESPONSE";

export const UPDATE_APPLICANT = "UPDATE_APPLICANT";
export const UPDATE_APPLICANT_REQUEST = "UPDATE_APPLICANT_REQUEST";
export const UPDATE_APPLICANT_RESPONSE = "UPDATE_APPLICANT_RESPONSE";

export const GET_ELIGIBLE_APPLICANTS_REQUEST =
  "GET_ELIGIBLE_APPLICANTS_REQUEST";
export const GET_ELIGIBLE_APPLICANTS_RESPONSE =
  "GET_ELIGIBLE_APPLICANTS_RESPONSE";

export const UPDATE_APPLICANT_DEDUCTION_REQUEST =
  "UPDATE_APPLICANT_DEDUCTION_REQUEST";
export const UPDATE_APPLICANT_DEDUCTION_RESPONSE =
  "UPDATE_APPLICANT_DEDUCTION_RESPONSE";

export const UPDATE_APPLICANT_REWARD_REQUEST =
  "UPDATE_APPLICANT_REWARD_REQUEST";
export const UPDATE_APPLICANT_REWARD_RESPONSE =
  "UPDATE_APPLICANT_REWARD_RESPONSE";

export const UPDATE_APPLICANT_REVERT_REWARD_REQUEST =
  "UPDATE_APPLICANT_REVERT_REWARD_REQUEST";
export const UPDATE_APPLICANT_REVERT_REWARD_RESPONSE =
  "UPDATE_APPLICANT_REVERT_REWARD_RESPONSE";

export const UPDATE_APPLICANT_REVERT_DEDUCTION_REQUEST =
  "UPDATE_APPLICANT_REVERT_DEDUCTION_REQUEST";
export const UPDATE_APPLICANT_REVERT_DEDUCTION_RESPONSE =
  "UPDATE_APPLICANT_REVERT_DEDUCTION_RESPONSE";

export const PROMOTE_APPLICANT_REQUEST = "PROMOTE_APPLICANT_REQUEST";
export const PROMOTE_APPLICANT_RESPONSE = "PROMOTE_APPLICANT_RESPONSE";

export const DEMOTE_APPLICANT_REQUEST = "DEMOTE_APPLICANT_REQUEST";
export const DEMOTE_APPLICANT_RESPONSE = "DEMOTE_APPLICANT_RESPONSE";

export const GET_CHECK_LISTING_PROFILE_REQUEST =
  "GET_CHECK_LISTING_PROFILE_REQUEST";
export const GET_CHECK_LISTING_PROFILE_RESPONSE =
  "GET_CHECK_LISTING_PROFILE_RESPONSE";
